import React, { createContext, useContext, useState, useEffect } from 'react';
import { TOKEN_TTL_MS } from '../utils/apiClient';


const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [authToken, setAuthToken] = useState(() => {
        const tokenData = localStorage.getItem('token');
        if (tokenData) {
            const { token, timestamp } = JSON.parse(tokenData);
            if (Date.now() - timestamp > TOKEN_TTL_MS) {
                localStorage.removeItem('token');
                return null;
            }
            return token;
        }
        return null;
    });

    // Optionally, synchronize the authToken state with localStorage
    useEffect(() => {
        if (authToken) {
            const item = {
                token: authToken,
                timestamp: new Date().getTime()
            };
            localStorage.setItem('token', JSON.stringify(item));
        } else {
            localStorage.removeItem('token');
        }
    }, [authToken]);

    const logout = () => {
        setAuthToken(null);
    };

    return (
        <AuthContext.Provider value={{ authToken, setAuthToken,logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
